$(function(){
    var pageNav = $('.page-navigation .page-navigation-list .page-navigation-item a');
    $(pageNav).on('click', function(){
        $(pageNav).parent().removeClass('__current');
        $(this).parent().toggleClass('__current');
    });
});